define.alias("ember-math-helpers/helpers/trunc", "calendar/helpers/trunc");